import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { handleCallback } from '../spotify/oauth.js'

export default function SpotifyCallback() {
  const [params] = useSearchParams()
  const nav = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    const code = params.get('code')
    const err = params.get('error')
    if (err) {
      setError(err)
      return
    }
    if (!code) {
      setError('No code returned from Spotify')
      return
    }
    handleCallback(code)
      .then(() => nav('/instructor', { replace: true }))
      .catch((e) => setError(e.message))
  }, [params, nav])

  return (
    <div className="min-h-full grid place-items-center px-6">
      <div className="card max-w-sm text-center">
        {error ? (
          <>
            <h1 className="font-bold mb-2">Sign-in failed</h1>
            <p className="text-sm text-red-300">{error}</p>
            <button className="btn-secondary mt-4" onClick={() => nav('/instructor')}>
              Try again
            </button>
          </>
        ) : (
          <p>Signing you in…</p>
        )}
      </div>
    </div>
  )
}
